var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailAdditional = function SvgEmailAdditional(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    viewBox: "0 0 11.8 10.15",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.434 0c.353 0 .692.136.942.377s.39.569.39.91v4.187a.48.48 0 0 1-.146.341.5.5 0 0 1-.353.141.5.5 0 0 1-.354-.14.48.48 0 0 1-.146-.342V1.287a.3.3 0 0 0-.096-.224.33.33 0 0 0-.23-.091H1.332a.33.33 0 0 0-.23.091.3.3 0 0 0-.096.224v6.778c0 .084.034.165.096.224a.33.33 0 0 0 .23.092h3.72a.5.5 0 0 1 .354.141c.094.09.147.213.147.341s-.053.25-.147.341a.5.5 0 0 1-.353.142H1.333c-.353 0-.692-.136-.942-.377A1.26 1.26 0 0 1 0 8.059V1.288C0 .946.14.618.39.377S.98 0 1.334 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.027 5.5a.5.5 0 0 1-.287-.093L.573 1.74a.5.5 0 0 1 .574-.813l4.88 3.46 4.88-3.46a.5.5 0 0 1 .573.813L6.313 5.407a.5.5 0 0 1-.286.093"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M8.73 5.624v2m0 2v-2m2 0h-2m-2 0h2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailAdditional);
export default ForwardRef;